import { api } from './customers'

export interface Procedure {
    id: number;
    procedureTitle: string;
    price: number;
    gst: number;
    activeStatus: any;
    createdAt: string;
    updatedAt: string;
};

export interface Compliants {
    id: number;
    complaintName: string;
    activeStatus: any;
    complaintsDescription: string;
    createdAt: string;
    updatedAt: string;
  }

type ProcedureTemplates = Procedure[];

export const MastersApi = api.injectEndpoints({
    endpoints: (build) => ({

        //Procedure Templates
        getProcedureTemplates: build.query<ProcedureTemplates,any>({
            query: ({ pageNo, name }) =>
                `procedure-template?page=${pageNo}&filter=${name}`,
        }),
        addProcedureTemplates: build.mutation<any, Partial<any>>({
            query: (body: any) => ({
                url: `procedure-template`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: Procedure }, meta, arg) => response.data,
        }),
        // getMedicineMaster: build.query<MedicineMaster, string>({
        //     query: (id) => `medicine/${id}`,
        //     transformResponse: (response: { data: MedicineMaster }, meta, arg) => response.data,
        // }),
        updateProcedure: build.mutation<void, Pick<Procedure, 'id'> & Partial<Procedure>>({
            query: ({ id, ...patch }) => ({
                url: `procedure-template/${id}`,
                method: 'PUT',
                body:patch,
            }),
        }),
        deleteProcedure: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `procedure-template/${id}`,
                    method: 'DELETE',
                }
            },
        }),


        // EHR Templates

        //1.Complaints
        getEHRComplaints: build.query<Compliants,any>({
                query: ({ pageNo, name }) =>
                    `complaints?page=${pageNo}&filter=${name}`,
        }),
        addEHRComplaints: build.mutation<Compliants, Partial<any>>({
            query: (body: any) => ({
                url: `complaints`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: Compliants }, meta, arg) => response.data,
        }),
        updateEHRComplaints: build.mutation<void, Pick<Compliants, 'id'> & Partial<Compliants>>({
            query: ({ id, ...patch }) => ({
                url: `complaints/${id}`,
                method: 'PUT',
                body:patch,
            }),
        }),
        deleteEHRComplaints: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `complaints/${id}`,
                    method: 'DELETE',
                }
            },
        }),

        //2.H&E
        getHandE: build.query<Compliants,any>({
            query: ({ pageNo, name }) =>
                `hematosylin?page=${pageNo}&filter=${name}`,
        }),
        addHandE: build.mutation<Compliants, Partial<any>>({
            query: (body: any) => ({
                url: `hematosylin`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: Compliants }, meta, arg) => response.data,
        }),
        updateHandE: build.mutation<void, Pick<Compliants, 'id'> & Partial<Compliants>>({
            query: ({ id, ...patch }) => ({
                url: `hematosylin/${id}`,
                method: 'PUT',
                body:patch,
            }),
        }),
        deleteHandE: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `hematosylin/${id}`,
                    method: 'DELETE',
                }
            },
        }),

        //3.Advice
        getEHRAdvice: build.query<Compliants,any>({
            query: ({ pageNo, name }) =>
                `advice?page=${pageNo}&filter=${name}`,
        }),
        addEHRAdvice: build.mutation<Compliants, Partial<any>>({
            query: (body: any) => ({
                url: `advice`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: Compliants }, meta, arg) => response.data,
        }),
        updateEHRAdvice: build.mutation<void, Pick<Compliants, 'id'> & Partial<Compliants>>({
            query: ({ id, ...patch }) => ({
                url: `advice/${id}`,
                method: 'PUT',
                body:patch,
            }),
        }),
        deleteEHRAdvice: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `advice/${id}`,
                    method: 'DELETE',
                }
            },
        }),

         //4.Diagnosis
         getEHRDiagnosis: build.query<any,any>({
            query: ({ pageNo, name }) =>
                `diagnosis?page=${pageNo}&filter=${name}`,
        }),
        addEHRDiagnosis: build.mutation<any, Partial<any>>({
            query: (body: any) => ({
                url: `diagnosis`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: any }, meta, arg) => response.data,
        }),
        updateEHRDiagnosis: build.mutation<void, Pick<any, 'id'> & Partial<any>>({
            query: ({ id, ...patch }) => ({
                url: `diagnosis/${id}`,
                method: 'PUT',
                body:patch,
            }),
        }),
        deleteEHRDiagnosis: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `diagnosis/${id}`,
                    method: 'DELETE',
                }
            },
        }),


        // Location (Branch)

        getLocationsMaster: build.query<any,any>({
            query: ({ pageNo, name }) =>
                `branch?page=${pageNo}&search=${name}`,
        }),
        getAllBranches: build.query<any,any>({
            query: () =>
                `branch-withoutpagination`,
          }),          
        addLocationsMaster: build.mutation<any, Partial<any>>({
            query: (body: any) => ({
                url: `branch`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: any }, meta, arg) => response.data,
        }),
        updateLocationsMasters: build.mutation<any,any>({
            query: ({ id, newFormData}) => ({
                url: `branch/${id}`,
                method: 'PUT',
                body:newFormData,
            }),
        }),
        updateLocationsStatus: build.mutation<void, Pick<any, 'id'> & Partial<any>>({
            query: ({ id, ...patch }) => ({
                url: `branch_status/${id}`,
                method: 'PUT',
                body:patch,
            }),
        }),
        deleteLocationsMaster: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `branch/${id}`,
                    method: 'DELETE',
                }
            },
        }),
    }),
})

export const {
    useGetProcedureTemplatesQuery,
    useAddProcedureTemplatesMutation,
    useUpdateProcedureMutation,
    useDeleteProcedureMutation,
    useGetEHRComplaintsQuery,
    useAddEHRComplaintsMutation,
    useUpdateEHRComplaintsMutation,
    useDeleteEHRComplaintsMutation,
    useGetHandEQuery,
    useUpdateHandEMutation,
    useAddHandEMutation,
    useDeleteHandEMutation,
    useGetEHRAdviceQuery,
    useAddEHRAdviceMutation,
    useUpdateEHRAdviceMutation,
    useDeleteEHRAdviceMutation,
    useGetEHRDiagnosisQuery,
    useAddEHRDiagnosisMutation,
    useUpdateEHRDiagnosisMutation,
    useDeleteEHRDiagnosisMutation,
    useGetLocationsMasterQuery,
    useGetAllBranchesQuery,
    useAddLocationsMasterMutation,
    useUpdateLocationsMastersMutation,
    useUpdateLocationsStatusMutation,
    useDeleteLocationsMasterMutation
} = MastersApi;
